var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"350px"}},[(_vm.dados)?_c('grafico-barras',{attrs:{"category-field":"anoMes","value-fields":_vm.valueFields,"dados":_vm.dados,"height":412,"unit-y-axis":`${_vm.$t('label.unidade_dinheiro')} `}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }